export const AUTH_REDIRECT_PARAM = "redirectTo";

const AUTH_ROUTE_PATTERN = /^\/(?:login|register)(?:$|[/?#])/;

export const getSafeRedirectPath = (
  value: string | null | undefined,
  fallback = "/"
) => {
  const redirectPath = value?.trim();

  if (!redirectPath) return fallback;
  if (!redirectPath.startsWith("/") || redirectPath.startsWith("//")) return fallback;
  if (redirectPath.includes("\\")) return fallback;
  if (AUTH_ROUTE_PATTERN.test(redirectPath)) return fallback;

  return redirectPath;
};

export const getCurrentPathFromRequest = (request: Request) => {
  const url = new URL(request.url);
  return `${url.pathname}${url.search}`;
};

export const getRedirectToFromRequest = (request: Request, fallback = "/") => {
  const url = new URL(request.url);
  return getSafeRedirectPath(url.searchParams.get(AUTH_REDIRECT_PARAM), fallback);
};

export const getRedirectToFromSearch = (search: string, fallback = "/") => {
  return getSafeRedirectPath(new URLSearchParams(search).get(AUTH_REDIRECT_PARAM), fallback);
};

export const getAuthRedirectTargetFromLocation = (
  pathname: string,
  search = "",
  fallback = ""
) => {
  const existingRedirect = getRedirectToFromSearch(search, "");
  if (existingRedirect) return existingRedirect;

  return getSafeRedirectPath(`${pathname}${search}`, fallback);
};

const buildAuthPath = (authPath: "/login" | "/register", redirectTo?: string | null) => {
  const safeRedirectTo = getSafeRedirectPath(redirectTo, "");
  if (!safeRedirectTo) return authPath;

  const params = new URLSearchParams({ [AUTH_REDIRECT_PARAM]: safeRedirectTo });
  return `${authPath}?${params.toString()}`;
};

export const buildLoginPath = (redirectTo?: string | null) => buildAuthPath("/login", redirectTo);

export const buildRegisterPath = (redirectTo?: string | null) => buildAuthPath("/register", redirectTo);
